<template>
	<div class="index" v-loading="loading">

		<HeaderInc ref="ref_header" :info="info"></HeaderInc>

		<div class="login_bg">
			<div class="login">
				<div class="login_box" v-show="regtype == 0">
					<div class="login_title">
						<h1>参赛者登录</h1>
						<span>您可以直接输入手机号和密码登录</span>
						<a class="help" @click="centerDialogVisible = true">帮助</a>
					</div>
					<el-form ref="login_form" :model="logininfo" :rules="rules" status-icon label-width="80px"
						class="demo-ruleForm">
						<el-form-item label="手机号" prop="phone">
							<el-input v-model="logininfo.phone" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="password">
							<el-input v-model="logininfo.password" type="password" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="验证" prop="login_norebots">
							<SliderCheck ref="login_Check" :successFun="loginSuccess" :errorFun="loginError">
							</SliderCheck>
						</el-form-item>
						<el-form-item>
							<a class="login_buttton" @click="submitForm('login_form')">登录</a>
							<a class="reg_buttton" @click="regtype=1">注册</a>
						</el-form-item>
						<el-form-item>
							<span class="el-color-999">忘记密码?</span>
							<router-link to="forget" class="el-color-red">找回密码</router-link>
						</el-form-item>
					</el-form>
				</div>
				<div class="reg_box" v-show="regtype == 1">
					<div class="login_title">
						<h1>账号申请</h1>
					</div>
					<el-form ref="reg_form" :model="reginfo" :rules="rules" status-icon label-width="80px"
						class="demo-ruleForm">
						<el-form-item label="手机号" prop="phone">
							<el-input v-model="reginfo.phone" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="真实姓名" prop="name">
							<el-input v-model="reginfo.name" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="发送短信">
							<SliderCheck ref="reg_Check" :successFun="regSuccess" :errorFun="regError"></SliderCheck>
						</el-form-item>
						<el-form-item label="验证码" prop="code">
							<el-input v-model="reginfo.code" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="password">
							<el-input v-model="reginfo.password" type="password" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item>
							<a class="login_buttton" @click="submitForm('reg_form')">注册</a>
						</el-form-item>
						<el-form-item>
							<span class="el-color-999">已有账号?</span>
							<el-link @click="regtype=0" type="danger">返回登录</el-link>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		
		<el-dialog v-model="centerDialogVisible" title="温馨提示" width="30%" destroy-on-close center>
			<div class="info_contact">
				<span>由于系统升级，2020.5-2021.10期间注册的用户使用手机号找回密码即可~</span>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="centerDialogVisible = false">关闭</el-button>
				</span>
			</template>
		</el-dialog>
		
	</div>
</template>
<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import SliderCheck from '@/components/SliderCheck.vue'
	import HeaderInc from '@/components/HeaderInc.vue'
	export default {
		name: 'Index',
		components: {
			SliderCheck,
			HeaderInc
		},
		props: {},
		data() {
			return {
				logininfo: {},
				reginfo: {},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在6到20个字符',
							trigger: 'blur'
						},
					],
					login_norebots: [{
						required: true,
						message: '请过人机滑块验证',
						trigger: 'blur'
					}, ],
					code: [{
						required: true,
						message: '请输入验证码~',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入真实姓名~',
						trigger: 'blur'
					}, ],
				},
				loading: false,
				regtype: 0,
				centerDialogVisible:false,
				info: {
					token: '',
					avatar: '',
					name: ''
				}
			}
		},
		created() {
			this.relogin();
		},
		methods: {
			submitForm(formName) {
				var that = this;
				that.$refs[formName].validate((valid) => {
					if (!valid) {
						return false;
					}
					let data = {}
					if (formName == 'reg_form') {
						data = that.reginfo
					}
					if (formName == 'login_form') {
						data = that.logininfo
					}
					data.ac = formName
					httpUtil.post('/api/', data, function(res) {
						localStorage.setItem('userinfo', JSON.stringify(res));
						if (res.status) {
							if (res.shenhe_status == '0') {
								if(formName == "reg_form"){
								that.$message({
									showClose: true,
									message: '注册成功,请完善信息~',
									type: 'success'
								})
								}
								setTimeout(function(){
									that.enterhome();
								},800)
							} else {
								that.enterinfo();
							}
						} else {
							that.$message.error(res.msg)
							return false
						}
					});

				})
			},
			enterinfo() {
				var that = this;
				that.$router.push({
					name: 'Work'
				})
			},
			enterhome() {
				var that = this;
				that.$router.push({
					name: 'Home'
				})
			},
			// 滑块验证成功回调
			loginSuccess() {
				this.logininfo.login_norebots = 1
				this.$refs['login_form'].validateField('login_norebots', rebots => {
					console.log(rebots);
				});

			},
			// 滑块验证失败回调
			loginError() {
				this.logininfo.reg_norebots = ''
			},
			// 滑块验证成功回调
			regSuccess() {
				var that = this
				that.$refs['reg_form'].validateField('phone', error => {
					if (!error) {
						that.reginfo.reg_norebots = 1;
						let data = {};
						data.ac = "regcode"
						data.phone = that.reginfo.phone
						httpUtil.post('/api/', data, function(res) {
							if (res.status) {
								that.$message({
									showClose: true,
									message: '短信发送成功~',
									type: 'success'
								})
							} else {
								that.$message.error(res.msg)
								that.$refs.reg_Check.reset()
							}

						});
					} else {
						that.$refs.reg_Check.reset()
						return false
					}
				})
			},
			// 滑块验证失败回调
			regError() {
				this.reginfo.reg_norebots = ''
			},
			relogin() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				let data = {}
				data.token = userinfo.token;
				data.ac = 'relogin'
				httpUtil.post('/api/', data, function(res) {
					localStorage.setItem('userinfo', JSON.stringify(res));
					if (res.token) {
						if (res.status == 1) {
							that.enterhome();
						} else {
							that.enterinfo();
						}
					}
				})
			}
		},

	}
</script>
<style>
	.index {
		width: 100%;
		height: 100vh;
		overflow-x: hidden;
		background: url(../assets/bg.jpg) no-repeat center;
		background-size: cover;
	}

	.warp {
		width: 1280px;
		margin: 0 auto;
		overflow: hidden;
	}
	
	
	.login_bg{
		width: 1280px;
		height: 561px;
		background: url(../assets/loginbox.jpg) no-repeat center;
		position: relative;
		left: 50%;
		top: 50%;
		margin-left: -640px;
		margin-top: -392.5px;
	}
	
	.login {
		width: 400px;
		height: 480px;
		padding: 40px;
		overflow: hidden;
		background: #FFFFFF;
	}

	.login_title {
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
	}
	
	.login_title h1 {
		font-size: 28px;
		font-weight: 400;
		color: #1A1A1A;
		line-height: 24px;
	}
	
	.login_title span {
		font-size: 12px;
		font-weight: 400;
		color: #999999;
		line-height: 24px;
	}

	.login_buttton {
		width: 310px;
		height: 50px;
		background: #bc963a;
		display: block;
		color: #FFF;
		border-radius: 25px;
		text-align: center;
		line-height: 50px;
		font-weight: 400;
		font-size: 18px;
		cursor: pointer;
	}

	.reg_buttton {
		width: 308px;
		height: 48px;
		border: #bc963a 1px solid;
		display: block;
		color: #bc963a;
		border-radius: 25px;
		text-align: center;
		line-height: 48px;
		font-weight: 400;
		font-size: 18px;
		margin-top: 10px;
		cursor: pointer;
	}

	.el-color-999 {
		color: #999999;
	}

	.el-color-red {
		color: #bc963a;
	}
	
	.help {
		display: block;
		position: absolute;
		left: 416px;
		top: 60px;
		color: #bc963a;
		font-size: 13px;
		cursor: pointer;
	}
	
	.info_contact span{
		display: block;
		font-size: 16px;
		line-height: 30px;
	}
</style>
